import React from 'react';
import {
  Box,
  Button,
  Flex,
  Grid,
  Icon,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Text,
} from '@chakra-ui/react';

import { RiArrowDropDownLine } from 'react-icons/ri';
import { PiMedalBold, PiMedalLight } from 'react-icons/pi';
import { MdAutoAwesome } from 'react-icons/md';

const ChatBotHeader = ({ name, menuBtnText, handleMenuBtnText }) => {
  return (
    <>
      <Text fontSize="34px" color="#1b254b" fontWeight="700">
        {name} Chat
      </Text>
      <Box textAlign="center">
        <Menu
          boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
          direction="rtl"
        >
          <MenuButton
            as={Button}
            width={{ base: '245px', sm: '290px' }}
            p={{ base: '25px 0px', md: '25px 0px' }}
            boxShadow="17px 10px 15px 3px rgba(112, 144, 176, 0.08)"
            background="none"
          >
            <Grid
              templateColumns="60px 1fr 35px"
              // gap={4}
              width="100%"
              alignItems="center"
            >
              <Box
                borderRadius="65px"
                background="linear-gradient(180deg, #FBFBFF 0%, #CACAFF 100%)"
                p="8px 14px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                ml="9px"
              >
                <Icon
                  as={MdAutoAwesome}
                  width="20px"
                  height="20px"
                  color="#422AFB"
                />
              </Box>
              <Box>
                <Text size={{ base: '0.75rem', sm: '1rem' }}>
                  {menuBtnText}
                </Text>
              </Box>
              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                <RiArrowDropDownLine style={{ fontSize: '28px' }} />
              </Box>
            </Grid>
            {/* <Flex justifyContent="center" alignItems="center">
              <Flex
                me="12px"
                borderRadius="65px"
                background="linear-gradient(180deg, #FBFBFF 0%, #CACAFF 100%)"
                p="8px 14px"
              >
                <Icon
                  as={MdAutoAwesome}
                  width="20px"
                  height="20px"
                  color="#422AFB"
                />
              </Flex>
              <Text>{menuBtnText}</Text>
              <RiArrowDropDownLine
                style={{ marginLeft: '6px', fontSize: '28px' }}
              />
            </Flex> */}
          </MenuButton>
          <MenuList minWidth="240px">
            <MenuOptionGroup
              defaultValue="General"
              type="radio"
              onChange={handleMenuBtnText}
              value={menuBtnText}
            >
              <MenuItemOption value="HighSchool level" icon={<PiMedalBold />}>
                <Text>High School</Text>
              </MenuItemOption>
              <MenuItemOption value="AP/IB level" icon={<PiMedalBold />}>
                <Text>AP/IB</Text>
              </MenuItemOption>
              <MenuItemOption value="College level" icon={<PiMedalBold />}>
                <Text>College</Text>
              </MenuItemOption>
              <MenuItemOption
                value="Middle School level"
                icon={<PiMedalBold />}
              >
                <Text>Middle School</Text>
              </MenuItemOption>
            </MenuOptionGroup>
          </MenuList>
        </Menu>
        <Text
          color="var(--chakra-colors-gray-500)"
          fontWeight="500"
          fontSize="var(--chakra-fontSizes-sm)"
          textAlign="center"
          pt="20px"
        >
          Select a difficulty level to get started
        </Text>
      </Box>
    </>
  );
};

export default ChatBotHeader;
